module.exports = __webpack_public_path__ + "static/img/1_8_4.3053168a.jpg";